import environment from 'environment';

import { getSessionToken } from 'util/parseSelectors';
import request from 'util/superagent';

export const findMacroSnippetByProductId = async (params) => {
  const sessionToken = getSessionToken();
  const paramsString = new URLSearchParams(params).toString();

  const response = await request
    .get(`${environment.app.serverApiUrl}/v1/macro-snippet/find-snippet-by-product-id?${paramsString}`)
    .set('Accept', 'application/json')
    .set('x-session-token', sessionToken);

  return response.body;
};
